import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { UserState } from 'src/app/modules/users/store/user.reducer';
import { SwitchViews } from 'src/app/shared/helpers/enums';
import { ModalDirective } from 'src/app/shared/directives/modal.directive';
import { PitchState } from 'src/app/modules/pitches/store/pitch.reducer';
import { SimpleActionCreator } from '../../../helpers/types';

@Component({
  selector: 'app-detail-view-analyses',
  templateUrl: './detail-view-analyses.component.html'
})
export class DetailViewAnalysesComponent {
  switchViews = SwitchViews;
  url = window.location.href;
  @Input() action: SimpleActionCreator<any>;
  @Input() modal: ModalDirective;
  @Input() state: Observable<UserState | PitchState>;
}
